import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { QuickWinSection } from '../components/QuickWinSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-main font-sans text-body" data-id="element-304">
      {/* Offer Banner */}
      <div className="bg-[#111111] text-[#F6F1E8] text-center py-2.5 px-4 text-sm tracking-wide" data-id="element-305">
        Oferta 24h: acceso al pack por{' '}
        <span className="font-bold text-accent" data-id="element-306">12€</span> con el código{' '}
        <span className="font-bold" data-id="element-307">HOY12</span>.
      </div>

      {/* Navigation / Logo */}
      <nav className="w-full py-3 px-6 z-50" data-id="element-308">
        <div className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-309">
          <div className="text-xl font-serif font-bold tracking-wider text-title" data-id="element-310">
            MÉTODO FACELESS<span className="text-accent" data-id="element-311">.</span>
          </div>
        </div>
      </nav>

      <main data-id="element-312">
        <HeroSection data-id="element-313" />
        <ProblemSection data-id="element-314" />
        <SolutionSection data-id="element-315" />
        <WhatInsideSection data-id="element-316" />
        <QuickWinSection data-id="element-317" />
        <TestimonialsSection data-id="element-318" />
        <BonusSection data-id="element-319" />
        <PricingSection data-id="element-320" />
        <FAQSection data-id="element-321" />
        <CTASection data-id="element-322" />
      </main>
      <Footer data-id="element-323" />
    </div>;
}